import React, { Suspense, lazy } from 'react';
import { httpClearCart } from '../../../Hooks/user/user.post.hooks';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { httpSendCoursePurchasedEmail } from '../../../Hooks/orders/order.hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  httpCaptureOrder,
  httpCreateOrder,
} from '../../../Hooks/orders/order.hooks';
import { useParams } from 'react-router-dom';
import { PaymentContainer } from '../Course.styles';
const PayPalScriptProvider = lazy(() =>
  import('@paypal/react-paypal-js').then((module) => ({
    default: module.PayPalScriptProvider,
  }))
);
const PayPalButtons = lazy(() =>
  import('@paypal/react-paypal-js').then((module) => ({
    default: module.PayPalButtons,
  }))
);

const PaymentStep = ({
  setTransactionId,
  // setStep,
  userId,
  courses,
  billingAddress,
  // transactionId,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ userId, transactionId }) =>
      httpSendCoursePurchasedEmail(userId, transactionId),
    onSuccess: () => {
      queryClient.invalidateQueries(['user', id, 'purchaseHistory']);
    },
    onError: (error) => {
      console.error('Error updating user:', error);
    },
  });
  const mutationClearCart = useMutation({
    mutationFn: (userId) => httpClearCart(userId),
    onSuccess: () => {
      queryClient.invalidateQueries(['user', id, 'purchaseHistory']);
    },
    onError: (error) => {
      console.error('Error updating user:', error);
    },
  });

  const initialOptions = {
    'client-id': process.env.REACT_APP_PAY_PAL_CLIENT_ID,
    'enable-funding': 'venmo',
    currency: 'CAD',
    components: 'buttons',
  };

  async function createOrder() {
    try {
      const courseIds = courses?.map((course) => course.courseId);
      const orderData = {
        courseIds,
        userId,
        billingAddress,
      };
      const response = await httpCreateOrder(orderData);
      const orderRes = await response.json();
      if (orderRes.id) {
        return orderRes.id;
      } else {
        throw new Error('Could not create order');
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  }
  async function onApprove(data) {
    try {
      const courseIds = courses?.map((course) => course.courseId);
      const orderData = {
        courseIds,
        userId,
        billingAddress,
      };
      const response = await httpCaptureOrder(data.orderID, orderData);
      const orderRes = await response.json();
      // console.log('Order Res', orderRes);
      const transaction =
        orderRes?.purchase_units?.[0]?.payments?.captures?.[0] ||
        orderRes?.purchase_units?.[0]?.payments?.authorizations?.[0];
      if (!transaction || transaction.status === 'DECLINED') {
        throw new Error(`Transaction ${transaction.status}: ${transaction.id}`);
      }
      setTransactionId(transaction.id);
      mutation.mutate({
        userId,
        transactionId: transaction.id,
      });
      mutationClearCart.mutate(userId);
      navigate('/transaction-completed', {
        state: {
          transactionId: transaction.id,
          courses,
          billingAddress,
          grandTotal:
            parseFloat(
              orderRes?.purchase_units?.[0].payments?.captures?.[0]?.amount
                ?.value
            ) || 0,
        },
      });

      // setStep(3);
    } catch (error) {
      console.error('Error capturing order:', error);
      alert('Transaction failed.');
    }
  }

  function onError(error) {
    console.error(error);
    alert('An error occurred during the payment process.');
  }
  return (
    <PaymentContainer>
      <h3>Payment</h3>
      <Suspense fallback={<div>Loading PayPal...</div>}>
        <PayPalScriptProvider options={initialOptions}>
          <div>
            <div>
              <PayPalButtons
                createOrder={createOrder}
                onApprove={onApprove}
                onError={onError}
                style={{
                  shape: 'pill',
                  layout: 'vertical',
                  color: 'gold',
                  label: 'pay',
                }}
              />
            </div>
          </div>
        </PayPalScriptProvider>
      </Suspense>
      <p className="m1T italicSpan">More payment options coming soon</p>
    </PaymentContainer>
  );
};
PaymentStep.propTypes = {
  setTransactionId: PropTypes.func,
  setStep: PropTypes.func,
  userId: PropTypes.string,
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      courseId: PropTypes.string,
    })
  ),
  billingAddress: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    adminArea1: PropTypes.string,
    adminArea2: PropTypes.string,
    countryCode: PropTypes.string,
    postalCode: PropTypes.string,
  }),
  transactionId: PropTypes.string,
};
export default PaymentStep;
